export default __webpack_public_path__ + "static/media/like.dfae2768.gif";